import React from "react";
import { cn } from "../../libs/utils";

/**
 * Minimal underline-style tabs. Generic (label/value pairs + controlled
 * active value) so any screen needing simple tabbed panels can reuse it
 * instead of building another one-off tab bar.
 */
const Tabs = ({ tabs, value, onChange, className }) => (
  <div className={cn("flex items-center gap-5 border-b border-slate-100", className)} role="tablist">
    {tabs.map((tab) => {
      const isActive = tab.value === value;
      return (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={isActive}
          onClick={() => onChange(tab.value)}
          className={cn(
            "relative pb-3 text-sm font-medium transition-colors",
            isActive ? "text-brand" : "text-slate-500 hover:text-slate-700"
          )}
        >
          {tab.label}
          {isActive && <span className="absolute inset-x-0 -bottom-px h-0.5 rounded-full bg-brand" />}
        </button>
      );
    })}
  </div>
);

export default Tabs;
